import React, { useState } from 'react'
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { Box } from 'core/components/Core'
import Modal from 'core/components/Modal'
import Typography from 'core/components/Typography'
import { Container, ErrorFileSvg, FileName, StyledError } from './style'

function FileError({ file }) {
  const [open, setOpen] = useState(false)

  let explanation = ''

  if (file?.error?.details?.minimum_allowed) {
    explanation = i18n.t('product.productUpload.imageMinimiumRequirementsWithErrorWarning', {
      minimum_allowed_height: file.error.details.minimum_allowed.height,
      minimum_allowed_width: file.error.details.minimum_allowed.width,
      sent_height: file.error.details.sent.height,
      sent_width: file.error.details.sent.width,
      error_details_unit: file.error.details.unit,
    })
  }

  return (
    <Container>
      <Box mb={2}>
        <BrokenImageOutlinedIcon color="error" fontSize="large" />
      </Box>
      <StyledError>{i18n.t('product.productUpload.error.title')}</StyledError>
      <FileName>{file.file.name}</FileName>
      {/* <Button onClick={() => setOpen(true)}>{i18n.t('product.productUpload.error.button')}</Button> */}
      <Modal
        open={open}
        maxWidth="sm"
        aria-labelledby="customized-dialog-title"
        textCancel={i18n.t('product.productUpload.buttonOk')}
        onCancel={() => setOpen(false)}
      >
        <Box textAlign="center" mb="20px">
          <ErrorFileSvg />
          <Typography variant="h3">{file.error.message}</Typography>
          <Typography fontSize="default">{explanation}</Typography>
        </Box>
      </Modal>
    </Container>
  )
}

FileError.propTypes = {
  file: PropTypes.object.isRequired,
}

export default FileError
